import type { Uuid } from '@common/types';
import type { WidgetErrorItem } from '@common/types/widget-errors.type';
import type { WidgetsErrorsState } from './widgets-errors.reducer';

import { createActionGroup, props } from '@ngrx/store';

const WidgetsErrorsActions = createActionGroup({
    source: 'PageStructure/WidgetsErrors',
    events: {
        'Set widgets errors': props<{ errors: WidgetsErrorsState }>(),
        'Update widget error': props<{ id: Uuid; error: WidgetErrorItem }>(),
        'Remove widget errors': props<{ widgetId: Uuid }>(),
    },
});

export default WidgetsErrorsActions;
